import { useLazyQuery, useMutation } from "@apollo/client/react";import React, { useEffect, useState } from 'react';
import './indicacionDetalle.scss';
import { FormControl, Grid, MenuItem, Select } from '@mui/material';
import { GET_ESTADOS_INDICACION_APROBACION } from '../../../../data/graphQL/queries/AdminIndicacion/getEstadosIndicacionAprobacion';
import { SAVE_RESPUESTA } from '../../../../data/graphQL/mutations/AdminIndicacion/SaveRespuesta';

import { TextInput } from '../../../../components/textInput/TextInput';
import { CustomButton } from '../../../../components/customButton/CustomButton';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { SelectInput } from '../../../../components/selectInput/SelectInput';

export const IndicacionDetalleRespComercial = ({ data, setDataDetalle, estados, edit }) => {

  const navigate = useNavigate();

  const ESTADO_PENDIENTE = 1;
  const ESTADO_NUEVO_CONTRATO = 3;
  const ESTADO_RECHAZADO = 4;

  const handleChange = (e) => {
    const { value, name } = e.target;
    setDataDetalle((data) => ({ ...data, [name]: value }));
  };

  useEffect(() => {
    setDataDetalle((data) => ({ ...data, "idEstadoComercial": data.idEstadoComercial }));
  }, []);

  const isFormValid = () => {
    if (data.idEstadoComercial == ESTADO_PENDIENTE) {
      toast.error('El estado debe ser distinto de Pendiente.');
      return false;
    }
    // justificación obligatoria en caso de rechazo o nuevo contrato
    if ((data?.idEstadoComercial == ESTADO_NUEVO_CONTRATO || data?.idEstadoComercial == ESTADO_RECHAZADO) && data.observacionComercial == "") {
      toast.error('El motivo es obligatorio.');
      return false;
    }
    return true;
  };

  const [saveRespuesta, { loading: saveLoading }] = useMutation(SAVE_RESPUESTA, {
    onCompleted: (data) => {
      if (data?.saveJustificacionIndicacionAprobacion.success) {
        toast.success("Se guardaron los cambios correctamente.");
        setTimeout(() => navigate('/adminIndicacionCOM'), 1000);
      } else {
        toast.error(data?.saveJustificacionIndicacionAprobacion?.error || "Ocurrió un error al guardar la respuesta.");
      }
    }
  });

  const handleGuardar = () => {
    if (isFormValid()) {
      saveRespuesta({
        variables: {
          input: {
            idIndicacionAprobacion: data?.idIndicacionAprobacion,
            idEvaluacion: parseInt(data?.contratoActual, 10),
            tipo: "C",
            idEstado: data?.idEstadoComercial,
            observacion: data.observacionComercial
          }
        }
      });
    }
  };

  return (
    <Grid container className='contrato-card-white'>
            <Grid size={{ xs: 12 }}>
                <div className='section-title'>Respuesta comercial</div>
            </Grid>
            <Grid container spacing={2} size={{ xs: 12 }}>
                <Grid size={{ xs: 24, sm: 12, md: 3, lg: 3 }}>
                    <FormControl sx={{ bgcolor: "white", width: "100%" }} size="small">                    
                    <SelectInput
              options={estados}
              label='Estados'
              onChange={handleChange}
              value={data?.idEstadoComercial}
              name='idEstadoComercial'
              margin={'normal'}
              disabled={!edit} />
            
                    </FormControl>
                </Grid>
                <Grid size={{ xs: 24, md: 12, lg: 12 }}>
                    <TextInput
            value={data?.observacionComercial}
            multiline
            rows={3}
            maxLength={2000}
            label='Motivo'
            name="observacionComercial"
            onChange={handleChange}
            disabled={!edit} />
          
                </Grid>
                {
        edit &&
        <Grid size={{ xs: 24, md: 12, lg: 12 }}>
                        <CustomButton
            variant='outlined'
            onClick={handleGuardar}
            size='small'
            isLoading={saveLoading}>
            
                            Grabar
                        </CustomButton>
                    </Grid>
        }
            </Grid>
        </Grid>);

};